import React from 'react';
import { Link } from 'react-router-dom';
import AppLogo from '../../atoms/AppLogo';
import Breadcrumb from '../../atoms/Breadcrumb';
import ProfileDropdown from '../../atoms/ProfileDropdown';
import './header.scss';

function Header({
  isSidebarOpen,
  onToggleSidebar
}) {
  return (
    <div className='passeazy-header'>
      <div className='passeazy-header-logo'>
        <button
          className='passeazy-header-hamburger'
          type='button'
          aria-label='Toggle navigation menu'
          aria-expanded={isSidebarOpen}
          onClick={onToggleSidebar}
        >
          <span className='passeazy-header-hamburger-line'></span>
          <span className='passeazy-header-hamburger-line'></span>
          <span className='passeazy-header-hamburger-line'></span>
        </button>
        <Link to="/home">
          <AppLogo/>
        </Link>
      </div>
      <div className='passeazy-header-container'>
        <div className='passeazy-header-row'>
          <Breadcrumb/>
          <ProfileDropdown/>
        </div>
      </div>
      
    </div>
  );
}

export default Header;
